var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('banner'),_c('anchor-nav'),_c('pluma'),_c('executives'),_c('trainers'),_c('footer-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }